/** Options for save-time warehouse host validators (Postgres, Redshift). */
export type WarehouseHostValidationOptions = {
  /** When true, localhost and private/reserved IP literals are accepted (dev/test only). */
  allowPrivate?: boolean;
};

/** RFC-1123-style DNS hostname grammar (labels, no underscores/commas/semicolons). */
export function isValidDnsHostname(host: string): boolean {
  const h = host.normalize('NFKC').trim().toLowerCase();
  if (!h || h.length > 253) return false;
  if (!/^[a-z0-9.-]+$/.test(h)) return false;
  if (h.startsWith('.') || h.endsWith('.') || h.includes('..')) return false;
  for (const label of h.split('.')) {
    if (!label || label.startsWith('-') || label.endsWith('-')) return false;
  }
  return true;
}
